import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { useEffect } from 'react';

interface LocationFilterProps {
  location: string;
  setLocation: (location: string) => void;
  locations: string[];
}

export function LocationFilter({ location, setLocation,locations}: LocationFilterProps) {

  return (
    <FormControl fullWidth>
      <InputLabel id="source-location-label">
       Source Location
      </InputLabel>
      <Select
        labelId="source-location-label"
        value={location}
        input={<OutlinedInput label="Source Location" />}
        onChange={(e) => setLocation(e.target.value)}
      >
         <MenuItem value={'ALL'}> All Locations</MenuItem>
        {locations.map((loc) => (
          <MenuItem key={loc} value={loc}>
            {loc}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
